import React, { Component } from "react";
import "../report-styles/searchBar.scss";
import SearchIcon from "../svgs/Search Duo.svg";

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="search-bar-select">
      <img src={SearchIcon} />
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBar;
